export default "__VITE_ASSET__20c2e52e__"